import { Select } from "@/components/ui/select/select";

import type { ShadowFloor } from "../../types/location-map";

import { NO_FLOOR_ID } from "../../utils/location/zone-floor";
import { toTitleCase } from "../../utils/shared/strings";

type ZoneFloorSelectProps = {
	floors: readonly ShadowFloor[];
	isDisabled?: boolean;
	onChange: (floorId: string) => void;
	size?: "md" | "sm";
	/** Floor id, or empty when the zone is unassigned. */
	value: string;
};

/**
 * Assign a zone to a floor on the same installation.
 * `onChange("")` clears the assignment.
 */
export const ZoneFloorSelect = ({
	floors,
	isDisabled = false,
	onChange,
	size = "md",
	value,
}: ZoneFloorSelectProps) => {
	if (floors.length === 0 && !value) return null;

	const items = [
		{ id: NO_FLOOR_ID, label: "No floor" },
		...floors.map((floor) => ({
			id: floor.id,
			label: toTitleCase(floor.name),
		})),
	];

	return (
		<Select
			isDisabled={isDisabled}
			items={items}
			label="Floor"
			onChange={(next) => {
				const floorId = next ? String(next) : NO_FLOOR_ID;
				onChange(floorId === NO_FLOOR_ID ? "" : floorId);
			}}
			placeholder="No floor"
			size={size}
			value={value || NO_FLOOR_ID}
		>
			{(item) => (
				<Select.Item id={item.id} key={item.id}>
					{item.label}
				</Select.Item>
			)}
		</Select>
	);
};
